import { useCallback, useState } from "react";
import { AxiosResponse } from "axios";
import { useInstanceValue } from "app/hooks/useInstanceValue";

function useDeleteData<T>(
  call: (...params) => Promise<AxiosResponse<T>>,
  additionalParams = {}
) {
  const [id, setId] = useState<number>();
  const [loading, setLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);

  const callRef = useInstanceValue(call);
  const additionalParamsRef = useInstanceValue(additionalParams);

  const deleteData = useCallback(
    async (idToDelete: number) => {
      setId(idToDelete);
      setLoading(true);
      setIsSuccess(false);
      setIsError(false);

      try {
        await callRef.current({
          id: idToDelete,
          ...additionalParamsRef.current,
        });
        setIsSuccess(true);
      } catch (error) {
        setIsError(true);
      } finally {
        setLoading(false);
      }
    },
    [additionalParamsRef, callRef]
  );

  return { loading, isSuccess, isError, id, deleteData };
}

export default useDeleteData;
